/**
 * Empty Snapshot State Component
 * 
 * Consistent empty state display for OS layer pages when no snapshots are available.
 */

import React from 'react';
import { GitBranch } from 'lucide-react';
import { DarkPanel } from '@/components/ui/DarkPanel';

interface EmptySnapshotStateProps {
  title?: string;
  message?: string;
  icon?: React.ReactNode;
}

export const EmptySnapshotState: React.FC<EmptySnapshotStateProps> = ({
  title = "No Snapshots Available",
  message = "Upload a XER file to create the first snapshot and view project data.",
  icon
}) => {
  return (
    <div className="p-8">
      <div className="max-w-2xl mx-auto">
        <DarkPanel className="p-6 text-center">
          {icon || <GitBranch className="h-12 w-12 text-gray-400 mx-auto mb-4 opacity-50" />}
          <h3 className="text-lg font-semibold mb-2 text-gray-300">{title}</h3>
          <p className="text-sm text-gray-500">{message}</p>
        </DarkPanel>
      </div>
    </div>
  );
};

